import React, { Component } from 'react';
import { View } from 'react-native';
import Modal from './shared/Modal';
import IntroSlides, { calcVideoSize } from './IntroSlides';
import { pOrT } from './styleConstants';

import { t } from '../utils/appUtils';

const DESC_HEIGHT = pOrT(45, 80);
const { videoHeight: VIDEO_HEIGHT, videoWidth: VIDEO_WIDTH } = calcVideoSize({
  descHeight: DESC_HEIGHT,
  offset: 65 + pOrT(90, 210),
  maxHeight: 300,
});

type Props = {
  onHide: () => void;
};

export default class HelpModal extends Component<Props> {
  onHide = () => {
    this.props.onHide();
  };

  render() {
    return (
      <Modal fullScreen onHide={this.onHide} title={t('help.help')} noBackgroundPaper>
        <View style={{ flex: 1, alignItems: 'center', paddingBottom: pOrT(10, 20) }}>
          <IntroSlides
            videoWidth={VIDEO_WIDTH}
            videoHeight={VIDEO_HEIGHT}
            descHeight={DESC_HEIGHT}
            showSkipButton={false}
            doneBtnLabel={<View />}
            onDoneBtnClick={() => {}}
            topOffset={pOrT(75, 75)}
            inModal
          />
        </View>
      </Modal>
    );
  }
}
